export class ContractParticipantDetails {
    providerId: number;
    providerName: string;
    providerNpi: string;
    assignedContractTags: string;
    noOfPatients: number;
    completedMeasures: number;
    totalMeasures: number;
    status: boolean;
    measureCompletion: number;
    careGaps: number;
    submissionDate?: Date;
    totalItems: number;
    contract: string;
    met: string;
    exclusion: number;
    performance: number;
    score: number;
    formatId:number;
}